import { render } from "./FilterCaminhoes.vue?vue&type=template&id=6d8cd514&scoped=true&ts=true"
import script from "./FilterCaminhoes.vue?vue&type=script&lang=ts"
export * from "./FilterCaminhoes.vue?vue&type=script&lang=ts"

import "./FilterCaminhoes.vue?vue&type=style&index=0&id=6d8cd514&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8cd514"]])

export default __exports__